const Actions = {
  Tabs: {
    OPEN: 'v.reports-of-sickness.actions.tabs.open',
    CLOSE: 'v.reports-of-sickness.actions.tabs.close',

    OPEN_NEW: 'v.reports-of-sickness.actions.tab.open-new',
    CLOSE_NEW: 'v.reports-of-sickness.actions.tab.close-new',

    OPEN_EDIT: 'v.reports-of-sickness.actions.tab.open-edit',
    OPEN_DETAILS: 'v.reports-of-sickness.actions.tab.open-details',

    OPEN_PERIOD: 'v.reports-of-sickness.actions.tab.open-period-new',
    OPEN_PERIOD_EDIT: 'v.reports-of-sickness.actions.tab.open-period-edit',
    OPEN_RECOVERY: 'v.reports-of-sickness.actions.tab.open-recovery-new',
    OPEN_RECOVERY_EDIT: 'v.reports-of-sickness.actions.tab.open-recovery-edit',

    // remove the current details tab, and create a new one with the new RoS.
    // OPEN_RECOVERY_EDIT: 'v.reports-of-sickness.actions.tab.open-recovery-edit',

    OPEN_IMPORT: 'v.reports-of-sickness.actions.tab.open-import',
    OPEN_IMPORT_NEW: 'v.reports-of-sickness.actions.tab.open-import-new'
  },
  REFRESH: 'v.reports-of-sickness.actions.refresh',
  CHANGE_INDEX_FILTER: 'v.reports-of-sickness.actions.index-filters.change'
};

const Mutations = {
  CLEAR: 'v.reports-of-sickness.mutations.clear',
  Tabs: {
    ADD: 'v.reports-of-sickness.mutations.tabs.add',
    OPEN: 'v.reports-of-sickness.mutations.tabs.open',
    CLOSE: 'v.reports-of-sickness.mutations.tabs.close'
  },
  SET_INDEX_FILTER: 'v.reports-of-sickness.actions.index-filters.set'
};

// TO-DO:: this needs to be better

export default {
  Actions,
  Mutations
};
